import * as React from 'react';

import * as style from './HeaderLayout.css';

export interface IHeaderLayoutProps {
  regions: React.ReactNode;
  searchInput: React.ReactNode;
  sorting: React.ReactNode;
}

export const HeaderLayout: React.FC<IHeaderLayoutProps> = props => {
  const { regions, searchInput, sorting } = props;

  return (
    <div className={style['container']}>
      <h1 className={style['title']}>Каталог застройщиков</h1>
      <div className={style['search']}>{searchInput}</div>
      <div className={style['regions']}>{regions}</div>
      <div className={style['sorting']}>{sorting}</div>
    </div>
  );
};
